import {
  getToken,
  setToken,
  removeToken,
  setItem,
  getItem,
  removeItem,
  clearItem,
} from '@/utils/auth'
import { loginApi } from '@/api/user'

export default {
  namespaced: true,
  state: () => ({
    token: getToken() || '',
    userinfo: getItem('userInfo') || '',
  }),
  mutations: {
    SET_TOKEN: (state, value) => {
      state.token = value
    },
    SET_USERINFO: (state, value) => {
      state.userinfo = value
    },
  },
  actions: {
    //登录
    login({ commit }, userinfo) {
      const { username, password } = userinfo
      return new Promise((resolve, reject) => {
        loginApi({
          userName: username.trim(),
          password: password,
        })
          .then(data => {
            const { Tag, Data, Message } = data

            console.log(data)

            if (Tag == '1') {
              commit('SET_TOKEN', Data.Token)
              setToken(Data.Token)

              const currentUserInfo = { userName: '', areaCode: '', areaType: '', areaName: '' }
              currentUserInfo['userName'] = Data.UserName
              currentUserInfo['areaCode'] = Data.areaCode
              currentUserInfo['areaType'] = Data.areaType
              currentUserInfo['areaName'] = Data.areaName

              commit('SET_USERINFO', JSON.stringify(currentUserInfo))
              setItem('userInfo', JSON.stringify(currentUserInfo))
            }
            resolve(data)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    //登出
    logout({ commit }) {
      return new Promise(resolve => {
        removeToken()
        clearItem()
        resolve()
      })
    },
  },
}
